import {Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { SubmitEntityData } from 'globals/store/share.data';
import { ShareWrapper } from './share-wrapper.component';
import { CustomQuestion } from 'globals/store/events.data';
import { BrandingData } from 'globals/store/publish.data';
import { Attendee } from 'globals/store/attendees.data';
import { AttendeeEditProfileComponent } from './share.editAttendeeForm.component';
import { BrandingWrapperComponent } from 'src/app/components/branding/branding-wrapper.component';
import { CommonModule } from '@angular/common';

@Component({
    selector: 'share-submit-attendee',
    template: `
<branding-wrapper
  [brandingData]="brandingData" 
  [style.--sitebackground]="brandingData?.template?.sitebackground || '#ffffff'">
  <div *ngIf="loading" class="loading">Loading...</div>
  <div *ngIf="!loading && !attendee" [innerHTML]="helpers.strWithBreak(inactiveUrlMessage)" class="sorry"></div>
  <div *ngIf="submitted"  class="thanks">
    Thank you! Your profile information has been submitted.
  </div>
  <share-edit-attendee-form *ngIf="!!attendee && !submitted"
    [topTitle]="(templateTitle || 'Call to Submit Attendees') + ': ' + (eventName || 'Unnamed Event')"
    [eventId]="eventId"
    [attendee]="attendee"
    [instructions]="instructions"
    [publishCode]="templateId"
    [customQuestions]="customQuestions"
    [error]="error"
    [processing]="processing"
    [template]="template"
    [callToSubmit]="true"
    (onSubmit)="submit()">
  </share-edit-attendee-form>
</branding-wrapper>


    `,
    styleUrls: ['./share.editPerformer.scss', './share-branding-wrapper.scss'],
    standalone: true,
    imports: [AttendeeEditProfileComponent, BrandingWrapperComponent, CommonModule],
})
export class AttendeeSubmitComponent extends ShareWrapper<AttendeeSubmitComponent> {
  templateId: string
  eventId: string
  eventName: string
  templateTitle: string
  instructions: string

  cannotSubmitMessage = "A new attendee profile can't be submitted at this time."
  attendee: Attendee
  inactiveUrlMessage = "This call for new attendees is not currently available."
  customQuestions: CustomQuestion[] = []
  
  brandingData: BrandingData

  constructor(private route:ActivatedRoute) {
    super()
    this.loading = true;
    document.title = "loading";

    this.route.params.subscribe(params=>{
      const { eventId, templateId } = params;
      if (!eventId || !templateId) {
        this.loading = false;
        document.title = "Unavailable";
        return
      }

      this.templateId = templateId
      this.eventId = eventId
      const queryData: SubmitEntityData = { entityType: 'attendee', submitTemplateId: templateId, eventId }
      this.publicService.loadSubmitEntityExtraData(queryData).then(data => {
        if (!data) {
          this.cannotLoad()
          return
        }
        const { eventTitle, customQuestions, templateTitle, instructions, brandingData } = data
        this.loading = false
        this.instructions = instructions
        this.brandingData = brandingData
        this.attendee = {
          social: [],
          labels: [],
          customQuestions: {},
          name: '',
        }
        this.eventName = eventTitle
        this.templateTitle = templateTitle
        this.customQuestions = customQuestions
        this.template = brandingData?.template
        document.title = `Call for new attendees`;
      }).catch(this.cannotLoad.bind(this))         
    })
  }

  cannotLoad(errorResponse = '') {
    if (errorResponse) console.error(errorResponse)
    this.loading = false
    this.showError(this.inactiveUrlMessage)
  }

  async submit() {
    const { templateId, eventId, attendee } = this
    const submitData: SubmitEntityData = { entityType: 'attendee', submitTemplateId: templateId, eventId, entity: attendee }
    await this.submitEntity(submitData, this.cannotSubmitMessage)
  }
}

